import type { RouterScrollBehavior } from "vue-router";

export function canRestoreScrollPosition(
  position: { top: number; left?: number },
  documentHeight: number,
  viewportHeight: number,
): boolean {
  return documentHeight >= position.top + viewportHeight;
}

export function isScrollLayoutReady(root: { dataset?: DOMStringMap } | null): boolean {
  return root === null || root.dataset?.scrollReady === "true";
}

/** Wait for async page content to make the saved offset reachable. */
export function restoreSavedPosition(position: { top: number; left?: number }): ReturnType<RouterScrollBehavior> {
  if (typeof window === "undefined" || typeof document === "undefined") return position;
  return new Promise((resolve) => {
    let settled = false;
    const timeout = window.setTimeout(() => { settled = true; resolve(false); }, 10_000);
    const check = (): void => {
      if (settled) return;
      if (isScrollLayoutReady(document.querySelector<HTMLElement>("[data-scroll-ready]"))
        && canRestoreScrollPosition(position, document.documentElement.scrollHeight, window.innerHeight)) {
        settled = true;
        window.clearTimeout(timeout);
        resolve(position);
        return;
      }
      window.requestAnimationFrame(check);
    };
    check();
  });
}
